// extracted by css-extract-rspack-plugin
export default {"fileViewer":"mYhD3rT3z2sXCJqA__fileViewer___"};